import { ISDSIcon } from "@sznds/icons";
import { node } from "~/util/dom";
import createSDSIcon from "../icon";
import { ISDSIconMulti } from "~/interfaces";

interface IProfileButtonProps {
	href?: string;
	className?: string;
	symbol?: ISDSIcon | ISDSIconMulti;
	text?: string;
	target?: string;
}

export default function createProfileButton({
	href,
	className = "",
	symbol,
	text,
	...rest
}: IProfileButtonProps = {}) {
	const button = href
		? node("a", { className: `${className} ui-profilebutton`, href, ...rest })
		: node("button", { className: `${className} ui-profilebutton`, type: "button", ...rest });

	if (symbol) {
		button.appendChild(createSDSIcon({ symbol }));
	}

	if (text) {
		button.appendChild(node("span", {}, text));
	}

	return button;
}
